<template>
<div>
    <loading-gif :loadingModal=loadingModal
        :topOfModal="topOfLoadingModal"
        :whichGifToPlay="whichGifToPlay"
        :bottomOfModal="bottomOfLoadingModal"
        :claimedList="claimedList"
        @loadingModal=closeLoadingModal></loading-gif>
    <div class="d-flex flex-md-row flex-column justify-content-center">
        <div class="minting-and-farm mt-5 mx-4">

            <!-- UNSTAKED NFT COMPONENT!!!! --> 
            <!-- UNSTAKED NFT COMPONENT!!!! --> 
            <!-- UNSTAKED NFT COMPONENT!!!! --> 
            <unstaked-nfts 
            @stakeClicked="stakeClicked"
            @refreshUnstakedNft="refreshUnstakedNfts"
            :unstakedNfts="paginations.unstaked" 
            :unstakedNftsWithoutPagination="unstakedNftsWithoutPagination"
            :loading="unstakedNFTSLoading"></unstaked-nfts>

            <!-- STAKED NFT COMPONENT!!!! --> 
            <!-- STAKED NFT COMPONENT!!!! --> 
            <staked-nfts 
            @stakedNFTClicked="stakedNFTclicked" 
            :choosenNfts="choosenNfts"
            :stakedNftsWithoutPagination="stakedNftsWithoutPagination"
            :stakedNftsChicken="paginations['Chicken']"
            :stakedNftsRooster="paginations['Rooster']" 
            :stakedNftsSnake="paginations['Snake']"
            :snakesLoading="stakedSnakesLoading"
            :chickensLoading="stakedChickensLoading"
            :roostersLoading="stakedRoostersLoading"
            ></staked-nfts>
        </div>
        <div>
            <div class=" d-flex justify-content-center flex-row mx-4" v-if="nftDetail.default">
                <welcome-parchment :noPaddingTop=true></welcome-parchment>
            </div>
            <div v-else class="nft-details mt-md-5 m-md-4">
                <div class="d-flex justify-content-center flex-row position-relative">
                    <span :class="nftDetailHeaderClass" :style="{'color' : chooseBackgroundColor }">{{chooseHeader}}</span>
                    <button @click="clearNftDetail()"  class="close-button">
                        <img src="../assets/images/x.png" alt="">
                    </button>
                </div>
                <div v-if="error" @click="error = ''" class="d-flex justify-content-center error-text flex-row windows-command-prompt">
                    <span>{{error.message}}</span>
                </div>
                <div v-else-if="choosenNfts[indexOfShowingNft].nftDetail.eggs != 0" class="d-flex justify-content-center flex-row egg-staked windows-command-prompt">
                    <span>Eggs currently in stake:{{allChoosenNftEggs}}</span>
                </div>
                <div class="d-flex justify-content-center flex-row">
                    <div class="nft-detail-image" :class="choosenNfts[indexOfShowingNft].nftDetail.image">
                        <img :src="choosenNfts[indexOfShowingNft].nftDetail.nft" alt="">
                        <div v-if="choosenNfts.length > 1" class="d-flex arrows-for-change-nft justify-content-around flex-row text-white fs-2"
                             style="cursor:pointer">
                            <button @click="indexOfShowingNft > 0 ? indexOfShowingNft-- : ''">&lt;</button>
                            <button @click="choosenNfts.length > 1 && indexOfShowingNft < choosenNfts.length - 1 ? indexOfShowingNft++ : ''">&gt;</button>
                        </div>
                        <div v-if="choosenNfts.length > 1" class="d-flex justify-content-end w-75 flex-row choseen-nft-length">
                            <span>{{indexOfShowingNft + 1}} / {{choosenNfts.length}}</span>
                        </div>
                    </div>
                </div>
                
                
                <div class="claim-and-claim-n-unstake-buttons d-flex justify-content-center flex-row" :class="chooseHeader == 'COOP' ? '' : 'mt-3'">
                    <button class="claim-button" @click="claimClicked(false)">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/stake-button-bg.webp" alt="">
                            <span class="claim-button-text">claim</span>
                        </div>
                    </button>
                    <button class="claim-button"  @click="claimClicked(true)">
                        <div class="d-flex flex-row justify-content-center position-relative">
                            <img src="../assets/images/connect-wallet-button.webp" alt="">
                            <span class="unclaim-button-text">claim n unstake</span>
                        </div>
                    </button>
                </div>
                <div v-if="choosenNfts[0].animal == 'Chicken'"  @click="riskyClaimClicked()" class="d-flex justify-content-center flex-row">
                    <div class="risky-claim-buttons">
                        <button class="claim-button">
                                <div class="d-flex justify-content-center flex-row position-relative">
                                    <img  src="../assets/images/connect-wallet-button.webp" alt="">
                                    <span class="risky-claim-button-text">risky claim</span>
                                </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import { ethers, utils } from "ethers";
import conf from "../conf";
import LoadingGif from './LoadingGif.vue';
import EggGame from '../contracts/EggGame.json';
import EggsToken from '../contracts/EGG.json';
import EggG from '../contracts/EggG.json';
import Coop from '../contracts/Coop.json';
import WelcomeParchment from './WelcomeParchment.vue';
import MintTube from './MintTube.vue';
import UnstakedNfts from './UnstakedNfts.vue';
import StakedNfts from './StakedNfts.vue';


export default {

  components: { LoadingGif , WelcomeParchment , MintTube, UnstakedNfts , StakedNfts },
    name:'farm-page-connected-wallet',
    data(){
        return{
            nftDetail:{
                default: true,
                header : '',
                image: '',
                riskyClaim: false,
                headerColor: '',
                nft:'',
                eggs: 0
            },
            claimedNFTS:{
                chicken: {}, // {nftID: claimedEggs}
                snake: {},
                rooster: {}
            },
            stakedChickensLoading: true,
            stakedSnakesLoading: true,
            stakedRoostersLoading: true,
            unstakedNFTSLoading: true,
            nftsLoaded: false,
            mintTubeWidth:0,
            provider: null,
            // eggsNftRelated
            mintingPaused: true,
            minted: 0,
            maxTokens: 30000,
            //  eggsGame related
            mintingPriceRepresentation: 0,
            mintingPrice: 0,
            isPublicSaleStarted: false,
            //  coopRelated
            // put coop related keys here
            // Eggs Token Related
            eggsTokenRepresentation: "",
            indexOfShowingNft: 0,
            nfts: [],
            paginations: {
                "unstaked": [],
                "Chicken": [],
                "Snake": [],
                "Rooster": [],
            },
            unStakedIndex:0,
            chickenIndex:0,
            roosterIndex:0,
            snakeIndex:0,
            choosenNfts:[],
            choosedToStakeNfts:[],
            totalStake: 0,
            error: '',
            loadingModal: false,
            whichGifToPlay: 'images/gifs/chicken-fall-failed.gif',
            topOfLoadingModal: 'Loading',
            bottomOfLoadingModal: 'Loading',
            choosedMintingAmount:1,
            unstakedNftsWithoutPagination: [],
            stakedNftsWithoutPagination: [],
            isRiskyClaimClicked: false,
            claimedList: [],
            postClaimReportToLoading: [],
            nftDetailHeaderClass:''
        }
    },
    created(){
        if (navigator.platform === 'MacIntel' || navigator.platform === 'MacPPC') {
            this.nftDetailHeaderClass = 'nft-detail-header-mac'
        }else{
            this.nftDetailHeaderClass = 'nft-detail-header'
        } 
    },
    computed:{
        allChoosenNftEggs(){
            let eggs = 0
            for(let i = 0 ; i< this.choosenNfts.length ; i++){
                eggs += parseFloat(this.choosenNfts[i].nftDetail.eggs)
            }
            return eggs.toFixed(2)
        },
        getInnerWidth(){
            return window.innerWidth
        },
        unstakedNft(){
            let dataFilter = this.nfts.filter(element => element.staked == false)
            return dataFilter
        },
        chooseBackgroundColor(){
            if(this.choosenNfts[0].animal == 'Chicken') return '#570303'
            else if(this.choosenNfts[0].animal == 'Rooster') return '#222222'
            else if(this.choosenNfts[0].animal == 'Snake') return '#362b62'
        },
        chooseHeader(){
            if(this.choosenNfts[0].animal == 'Chicken') return 'COOP'
            else if(this.choosenNfts[0].animal == 'Rooster') return 'LAIR'
            else if(this.choosenNfts[0].animal == 'Snake') return 'CAVE'
        },
        eggsGameContract () {
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return  new ethers.Contract( conf.eggsGameAddress, EggGame.abi, this.provider.getSigner())
        },
        eggsNFT () {
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return  new ethers.Contract( conf.eggsNFTAddress, EggG.abi, this.provider.getSigner())
        },
        eggsToken () {
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return new ethers.Contract( conf.eggsTokenAddress, EggsToken.abi, this.provider.getSigner())
        },
        coopContract() { 
            this.provider = this.provider || new ethers.providers.Web3Provider(window.ethereum)
            return new ethers.Contract( conf.coopAddress, Coop.abi, this.provider.getSigner())
        }
    },
    methods: {
        initiate(){
            this.getEggsBalance()
            this.getNfts();
            this.getStakedNfts()
            this.rewardTicker()
        },
        addNft2Collection(tokenID, tokenTraits, staked){
            const places = {
                "Chicken": ["COOP", "coop-bg", "#570303"],
                "Snake": ["CAVE", "cave-bg", "#362b62"],
                "Rooster": ["LAIR", "lair-bg", "#222222"]
            }
            let buff = new Buffer(tokenTraits.replace("data:application/json;base64,", ""), 'base64');
            let text = buff.toString('ascii');
            let structuredData = JSON.parse(text)
            let name = structuredData.name.split(" ")[0]
            this.nfts.push(
                {
                    "staked": staked,
                    "id": tokenID.toString(),
                    "animal": structuredData.name.split(" ")[0],
                    "nftDetail": {
                        "default": false,
                        "header": places[name][0],
                        "image": places[name][1],
                        "riskyClaim": true,
                        "headerColor": places[name][2],
                        "nft": structuredData.image,
                        "eggs": 0
                }
            })
        },
        addNftFromMoralis2Collection(rawNFT, staked){
            if (rawNFT.metadata == null){
                console.log("this nft is null", rawNFT.token_id)
                return
            }
            const places = {
                "Chicken": ["COOP", "coop-bg", "#570303"],
                "Snake": ["CAVE", "cave-bg", "#362b62"],
                "Rooster": ["LAIR", "lair-bg", "#222222"]
            }
            let structuredData = JSON.parse(rawNFT.metadata)
            let name = structuredData.name.split(" ")[0]
            this.nfts.push(
                {
                    "staked": staked,
                    "id": rawNFT.token_id,
                    "animal": structuredData.name.split(" ")[0],
                    "nftDetail": {
                        "default": false,
                        "header": places[name][0],
                        "image": places[name][1],
                        "riskyClaim": true,
                        "headerColor": places[name][2],
                        "nft": structuredData.image,
                        "eggs": 0
                }
            })
        },
        paginate(dataFilter, tip){
            let pageNumbers = []
            this.paginations[tip] = []
            let index = 0
            
            if(dataFilter.length > 4){
                //pagination count manager
                let paginationPageCount = dataFilter.length / 4
                let paginationInsideCount = 4

                //on mobile pagination inside 3 member
                if(this.getInnerWidth < 800){
                    paginationPageCount = dataFilter.length / 3
                    paginationInsideCount = 3
                }
                for(let i = 0 ; i < Math.ceil(paginationPageCount) ; i++){
                    pageNumbers.push({pageNumber:i+1 , pageInside:[dataFilter.slice(index,index+paginationInsideCount)]})
                    index = index+paginationInsideCount
                }
            }else{
                pageNumbers.push({pageNumber:0 , pageInside:[dataFilter]})
            }
            if (tip == "unstaked"){
                this.unstakedNftsWithoutPagination = dataFilter
            }
            this.paginations[tip] = pageNumbers
        },
        specifyStakedNft(animal){
            let dataFilter;
            if (animal == "unstaked"){
                dataFilter = this.nfts.filter( element => element.staked == false)
            }else{
                dataFilter = this.nfts.filter( element => element.animal == `${animal}` && element.staked == true)
                // console.log("filtering done", animal)
                this.stakedNftsWithoutPagination = this.nfts.filter(element => element.staked == true)
            }
            return this.paginate(dataFilter, animal)
        },
        unstakedNFTclicked(nft){
            const index = this.choosedToStakeNfts.findIndex(i => i.id == nft.id)
            if (index > -1){
                this.choosedToStakeNfts.splice(index , 1)
            }else{
                this.choosedToStakeNfts.push(nft)
            }
        },
        stakedNFTclicked(nft){
            let counter=  0
            for(let [i , nfts] of this.choosenNfts.entries()){
                if(nft.id == nfts.id){
                    this.choosenNfts.splice(i, 1)
                    counter++
                }
            }
            this.choosenNfts = this.choosenNfts.filter((e) => {return e != null;})
            if(this.choosenNfts.length == 0)
                this.nftDetail.default = true
            if(counter == 0){
                this.choosenNfts.push(nft)
                this.nftDetail.default = false
            }
            for(let [i , nfts] of this.choosenNfts.entries()){
                    if(nfts.animal !== nft.animal){
                        delete this.choosenNfts[i]
                        this.indexOfShowingNft = 0
                    }
            }
            this.choosenNfts = this.choosenNfts.filter((e) => {return e != null;})
        },
        async getNFTDetail(tokenID, staked){
            if (conf.provider == "moralis"){
                await axios.get(`https://deep-index.moralis.io/api/v2/nft/${conf.eggsNFTAddress}/${tokenID}?chain=mumbai&format=decimal`,
                {"headers": {"X-API-Key": conf.providers.moralis.key}})
                .then((result) => {
                    this.addNftFromMoralis2Collection(result.data, staked)
                })
                .catch((error) => {
                    console.log(error)
                })
            }else {
                await this.eggsNFT.tokenURI(tokenID)
                .then((tokenTraits) => {
                    // console.log(`got token traits of ${tokenID} (staked: ${staked})`)
                    this.addNft2Collection(tokenID, tokenTraits, staked)
                })
                .catch((error) => {console.log(`${tokenID} got error: ${error.error}`)})
            }
        },
        async getStakedChickens(){
            this.stakedChickensLoading = true
            await this.coopContract.getStakedChickens()
            .then(async (rawChickenIDList) => {
                console.log(`Staked Chickens: ${rawChickenIDList}`)
                let tokenIDList = rawChickenIDList.split(",")
                if (tokenIDList.length < 1){this.stakedSnakesloading = false}
                for (let tokenID of tokenIDList){
                    if (tokenID){
                        await this.getNFTDetail(tokenID, true)
                    }
                }
                this.specifyStakedNft('Chicken')
                this.stakedChickensLoading = false
            })
            .catch((error) => {
                this.stakedChickensLoading = false
                console.log(`Getting chicken list got error: ${error.error}`)}
            )
        },
        async getStakedSnakes(){
            this.stakedSnakesLoading = true
            this.coopContract.getStakedSnakes()
            .then(async (rawSnakeIDList) => {
                let tokenIDList = rawSnakeIDList.split(",")
                console.log(`Staked Snakes: ${tokenIDList}`)
                if (tokenIDList.length < 1){this.stakedSnakesLoading = false}
                for (let tokenID of tokenIDList){
                    if (tokenID){
                        await this.getNFTDetail(tokenID, true)
                    }
                }
                this.specifyStakedNft('Snake')
                this.stakedSnakesLoading = false
            })
            .catch((error) => {
                console.log(`Getting snake list got error: ${error.error}`)
                this.stakedSnakesLoading = false
                }
            )
        },
        async getStakedRoosters(){
            this.stakedRoostersLoading = true
            this.coopContract.getStakedRoosters()
            .then(async (rawRoosterIDList) => {
                let roosterIDList = rawRoosterIDList.split(",")
                console.log(`Staked Roosters: ${roosterIDList}`)
                if (roosterIDList.length < 1){this.stakedRoostersLoading = false}
                for (let tokenID of roosterIDList){
                    if (tokenID){
                        await this.getNFTDetail(tokenID, true)
                    }
                }
                this.specifyStakedNft('Rooster')
                this.stakedRoostersLoading = false
            })
            .catch((error) => {
                console.log(`Getting rooster list got error: ${error.error}`)
                this.stakedRoostersLoading = false
                }
            )
        },
        async getStakedNfts(){
            this.getStakedChickens()
            this.getStakedSnakes()
            this.getStakedRoosters()
        },
        async getNftsInternal(){
            if (conf.provider == "moralis"){
                await axios.get(`https://deep-index.moralis.io/api/v2/${ethereum.selectedAddress}/nft/${conf.eggsNFTAddress}?chain=mumbai&format=decimal`,
                {"headers": {"X-API-Key": "dwzfgOXQJk8KQhXTJ2iTvlTXu6JbHtb5l1v124cIgcwkb37MMaBlINuaODCbAnY3"}})
                .then((result) => {
                    for (let rawNFT of result.data.result){
                        this.addNftFromMoralis2Collection(rawNFT, false)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
            }else{
                let myAddress = ethereum.selectedAddress;
                console.log("Checking unstaked balance", conf.eggsNFTAddress)
                let nftBalance;
                await this.eggsNFT.balanceOf(myAddress).then((result) => {nftBalance = parseInt(utils.formatUnits(result, "wei"))})
                console.log("UNSTAKED NFTS :", nftBalance)
                let counter = 0
                // while (this.nfts.length < nftBalance){
                // DEBUG PURPOSES remove these lines after development !!
                nftBalance = nftBalance > 14 ? 14: nftBalance
                while (counter < nftBalance){
                    await this.eggsNFT.tokenOfOwnerByIndex(myAddress, counter)
                    .then(async (tokenID) => {
                        // console.log(`token id: ${tokenID}`)
                        await this.getNFTDetail(tokenID, false)
                    })
                    .catch((error) => {console.log(`${counter} got error: ${error.error}`)})
                    counter++
                }
            }
        },
        async getNfts(){
            this.unstakedNFTSLoading = true
            await this.getNftsInternal().then(() => {
                this.specifyStakedNft('unstaked')
                this.unstakedNFTSLoading = false
            })
        }, 
        chickenClaimed(rawtokenID, owed, animal, unstake, risked){
            let tokenID = utils.formatUnits(rawtokenID._hex, "wei")
            console.log("chickenClaimedFinishCase started", tokenID, this.choosenNfts)
            // find index if emitted token id is ours
            let myToken = this.choosenNfts.findIndex((nft) => nft.id == tokenID)
            if (myToken == -1){
                // console.log(`its not ${tokenID}`)
                return
            }
            this.choosenNfts.splice(myToken, 1)
            
            if (unstake){
                for (let nft of this.nfts){
                    if (nft.id == tokenID){
                        nft.staked = false
                        this.specifyStakedNft('unstaked')
                        this.specifyStakedNft(nft.animal)
                    }
                }
            }

            if (this.choosenNfts.length == 0){
                if (this.isRiskyClaimClicked){
                    // play  risky claim cases
                    this.playRiskyClaimResult(tokenID, owed , risked)
                }else {
                    // play classic claim
                    this.playClaimSuccess(animal,tokenID, owed , unstake)
                }
                this.clearNftDetail()
            }else{
                // wait until all sent token responses back 
                console.log("still we need to wait other nft claim results:", this.choosedToStakeNfts)
            }
        },
        clearNftDetail(){
            this.choosenNfts = []
            this.nftDetail.default = true
        },
        stakeClicked(choosedToStakeNfts){
            // todo why this was turned into a positional argument ? 
            this.choosedToStakeNfts = choosedToStakeNfts
            if (choosedToStakeNfts.length < 1){
                this.$emit('openToast' , {variant: 'danger' , message: `Choose nfts to stake ?`})
                return
            }
            let idsToStake = choosedToStakeNfts.map(n => {return n.id})
            this.coopContract.addManyToCoopAndCave(ethereum.selectedAddress, idsToStake)
            .then((result) => {
                this.topOfLoadingModal = 'LOADING'
                this.whichGifToPlay = 'images/gifs/all-together-stake.gif'
                this.bottomOfLoadingModal = 'Entring The Farm'
                this.loadingModal = true
                
            })
            .catch((error) => {
                this.loadingModal = false
                this.handleContractErrorMessage(error)
            })
            
        },
        closeLoadingModal(value){
            this.loadingModal = value
            this.claimedList = []
        },
        handleContractErrorMessage(response){
            console.log(response)
            let Message;
            try{
                Message = response.data.message
                Message = Message.replace("VM Exception while processing transaction: revert", "")
                if (Message === ""){
                    Message = "An error occured."
                }
                this.$emit('openToast' , {variant: 'danger' , message: `Error: ${Message}`})
            }catch{
                Message = response
            }
        },
        async calculateReward(tokenID){
            let reward;
            await this.coopContract.calculateRewards(tokenID)
            .then((rawReward) => {
                // console.log(tokenID, rawReward)
                reward = (utils.formatEther(rawReward) * 1).toFixed(2)
            })
            .catch((error) => {console.log(`${tokenID} got error: ${error.error}`)})
            return reward
        },
        async calculateSnakeReward(tokenID){
            let reward;
            await this.coopContract.monitorSnakeReward(tokenID)
            .then((rawReward) => {
                // console.log(tokenID, rawReward)
                reward = (utils.formatEther(rawReward) * 1).toFixed(2);
            })
            .catch((error) => {console.log(`${tokenID} got error: ${error.error}`)})
            return reward
        },
        calculateRewards(){
            this.nfts.map((nft) => {
                if (nft.staked == true && nft.animal == "Chicken"){
                    this.calculateReward(nft.id)
                    .then((reward) => {
                        // console.log(reward)
                        nft.nftDetail.eggs = reward
                        })
                }else if (nft.staked == true && nft.animal == "Snake"){
                    this.calculateSnakeReward(nft.id)
                    .then((reward) => {
                        nft.nftDetail.eggs = reward
                        })
                }
            })
        },
        async getEggsBalance(){
            let balance;
            await this.eggsToken.balanceOf(ethereum.selectedAddress).then((result) => {balance = utils.formatEther(result)})
            // console.log(`BALANCE: ${balance}`)
            // console.log(`contract address: ${conf.eggsTokenAddress}`)
            this.$emit('eggsBalance' , balance)
        },
        claimClicked(unstake){
            if (this.choosenNfts.length < 1){
                this.$emit('openToast' , {variant: 'danger' , message: `Choose nfts to claim`})
                return
            }
            let nftIds = []
            let postClaimReport = []
            this.choosenNfts.map((nft) => {
                nftIds.push(nft.id)
                // freeze rewards before claiming
                postClaimReport.push({id: nft.id, eggs: nft.nftDetail.eggs , animal:nft.animal.toLowerCase() })
                }) 
            let GROUP_DEFINITION_NFT = this.choosenNfts[0]
            
            this.coopContract.claimManyFromCoopAndCave(nftIds, unstake)
            .then(() => {
                // FIXME just for demonstration purposes we using 0 indexed nft
                let DEMONSTRATION_NFT = this.choosenNfts[0]
                postClaimReport.map((nft) => {
                    this.claimedNFTS[GROUP_DEFINITION_NFT.animal.toLowerCase()][nft.id]=nft.eggs
                })
                this.postClaimReportToLoading = postClaimReport
                this.playClaimStarted(DEMONSTRATION_NFT.animal)
            })
            .catch((error) => {
                this.loadingModal = false
                this.handleContractErrorMessage(error)
            })
            
        },
        playClaimStarted(animal){
            const differences = {
                chicken: {
                    wgf: "images/gifs/egganimation.gif",
                    bOLM: "Collecting $EGGS",
                },
                snake: {
                    wgf: 'images/gifs/snakerun4.gif',
                    bOLM: 'Collecting tax from the chickens',
                },
                rooster: {
                    wgf: "images/gifs/rooster-animation.gif",
                    bOLM: "Collecting payment for protection",
                }
            }
            let preset = differences[animal.toLowerCase()]
            this.whichGifToPlay = preset.wgf
            this.topOfLoadingModal= 'Loading'
            this.bottomOfLoadingModal = preset.bOLM
            this.loadingModal = true
        },
        playRiskyClaimResult(tokenID, eggsClaimed , risked){
            eggsClaimed = (utils.formatEther(eggsClaimed) * 1)
            let eggsPaid = (eggsClaimed / 3)
            const differences = {
                1: {
                    bOLM2: `Collected ${(eggsClaimed / 3 ).toFixed(2)} $EGGS from chicken #${tokenID} after paying 2/3 of their ${(eggsPaid * 2).toFixed(2)} as tax to the snakes`,
                    tOLM: "Boom !",
                    wgf: 'images/gifs/chicken-fall-failed.gif',
                },
                2: {
                    bOLM2: `Collected ${eggsClaimed.toFixed(2)} $EGGS from chicken #${tokenID}`,
                    tOLM: "sssh !!",
                    wgf: 'images/gifs/chicken-fall.gif',
                }
            }
            let preset = differences[risked]
            let timer = setInterval(()=> {
                this.whichGifToPlay = "images/gifs/eggdrop.gif"
                this.topOfLoadingModal = 'How it Played out'
                this.bottomOfLoadingModal= preset.bOLM2
                clearInterval(timer)
            }, 5000)
            let secondTimer = setInterval(()=> {
                this.loadingModal = false
                clearInterval(secondTimer)
            }, 10000)
            let balanceTimer = setInterval(()=> {
                    this.getEggsBalance()
                    clearInterval(balanceTimer)
                },3000)
        },
        playClaimSuccess(animal, tokenID, eggsClaimed , unstake){
            console.log(eggsClaimed, tokenID)
            eggsClaimed = (utils.formatEther(eggsClaimed) * 1)
            let eggsPaid = (eggsClaimed / 2)
            const differences = {

                chicken: {
                    bOLM2: `Collected ${(eggsClaimed).toFixed(2)} $EGGS from chicken #${tokenID} after paying 1/3 of their ${(eggsPaid).toFixed(2)} as tax to the snakes`,
                    wgf: 'images/gifs/chickensigara.gif',
                    wgfNotUnstake: 'images/gifs/eggdrop.gif',
                    bOLM3: `Chicken #${tokenID} successfully exited the coop`
                },
                snake: { 
                    bOLM2: `Snake #${tokenID} collected a tax of ${eggsClaimed}`,
                    wgf: 'images/gifs/snake-alco.gif',
                    wgfNotUnstake: 'images/gifs/eggdrop.gif',
                    bOLM3: `Snake #${tokenID} successfully exited the cave`
                },
                rooster: {
                    bOLM2: `Rooster #${tokenID} got payed ${eggsClaimed}`,
                    wgf: 'images/gifs/horozsleep.gif',
                    wgfNotUnstake: 'images/gifs/eggdrop.gif',
                    bOLM3: ` Rooster #${tokenID} successfully exited the lair`
                }
            }
            let preset = differences[animal.toLowerCase()]

            //Multiple Claim Loading gif
            if(this.postClaimReportToLoading.length > 1){
                this.postClaimReportToLoading.map((nft) => {
                    nft.whichGifToPlay = differences[nft.animal].wgfNotUnstake
                    if(nft.animal === 'chicken')
                        nft.bottomOfModal = `Collected ${((nft.eggs / 3)*2).toFixed(2)} $EGGS from chicken #${nft.id} after paying 1/3 of their ${(nft.eggs / 3).toFixed(2)} as tax to the snakes`
                    else
                        nft.bottomOfModal =  `${nft.animal} #${nft.id} collected a tax of ${(nft.eggs)}`
                    nft.topOfModal = 'How it Played out'
                })
                if(unstake){
                    let exitingFarm = {
                        bottomOfModal: 'Exiting The Farm',
                        topOfModal: '',
                        whichGifToPlay: preset.wgf
                    }
                    this.postClaimReportToLoading.push(exitingFarm)
                }
                this.claimedList = this.postClaimReportToLoading
                let balanceTimer = setInterval(()=> {
                    this.getEggsBalance()
                    clearInterval(balanceTimer)
                },3000)
            }else{
                let timer = setInterval(()=> {
                this.whichGifToPlay = "images/gifs/eggdrop.gif"
                this.topOfLoadingModal = 'How it Played out'
                this.bottomOfLoadingModal= preset.bOLM2
                clearInterval(timer)
                }, 5000)
                if(unstake){
                    let secondTimer = setInterval(()=> {
                        this.whichGifToPlay = preset.wgf
                        this.topOfLoadingModal = ''
                        this.bottomOfLoadingModal= preset.bOLM3
                        clearInterval(secondTimer)
                    }, 10000)
                    let thirdTimer = setInterval(()=> {
                        this.loadingModal = false
                        this.getEggsBalance()
                        clearInterval(thirdTimer)
                    }, 15000)
                }else{
                    let secondTimer = setInterval(()=> {
                        this.loadingModal = false
                        this.getEggsBalance()
                        clearInterval(secondTimer)
                    }, 10000)
                }
            }
            
        },
        refreshNFTs(){
            this.nfts = []
            this.getEggsBalance()
            this.getNfts()
            this.getStakedNfts()
        },
        riskyClaimClicked(){
            this.isRiskyClaimClicked = true
            if (this.choosenNfts.length < 1){
                this.$emit('openToast' , {variant: 'danger' , message: `Choose nfts to risk`})
                return
            }
            let nftIds = []
            this.choosenNfts.map((nft) => {
                nftIds.push(nft.id)
                })
            let GROUP_DEFINITION_NFT = this.choosenNfts[0]
            this.coopContract.riskyClaimChickenList(nftIds)
            .then((result) => {
                this.whichGifToPlay = 'images/gifs/egganimation.gif'
                this.topOfLoadingModal = 'Risk Taken'
                this.bottomOfLoadingModal = `Chicken #${GROUP_DEFINITION_NFT.id} trying to hide from the snakes`
                this.loadingModal = true
            })
            .catch((error) => {
                this.isRiskyClaimClicked = false
                this.loadingModal = false
                this.handleContractErrorMessage(error)
            })
        },
        tokenStaked(rawtokenID){
            let tokenID = utils.formatUnits(rawtokenID._hex, "wei")
            // console.log("tokenStakedFinishCase started", tokenID)
            // find index if emitted token id is ours
            let myToken = this.choosedToStakeNfts.findIndex((nft) => nft.id == tokenID)
            if (myToken == -1){
                // console.log(`its not ${tokenID}`)
                return
            }
            for (let nft of this.nfts){
                if (nft.id == tokenID){
                    console.log("nft staked do placing.")
                    nft.staked = true
                    this.specifyStakedNft('unstaked')
                    this.specifyStakedNft(nft.animal)
                }
            }
            this.choosedToStakeNfts.splice(myToken, 1)
            if (this.choosedToStakeNfts.length == 0){
                this.loadingModal = false
                for (let stakedNFT in this.choosedToStakeNfts){
                    let index = this.unstakedNft.findIndex(i => i.id == stakedNFT.id)
                    this.unstakedNft.splice(index, 1)
                }
                // this.refreshNFTs()
            }else{
                // wait until all sent token responses back 
                console.log("still we need to wait other staking nft results:", this.choosedToStakeNfts)
            }
        },
        rewardTicker(){
            // console.log("STARTING TO CALCULATE REWARDS")
            this.ticker = setInterval(async () => {
                await this.calculateRewards(this.rewardTicker)
            }, 15000);
        },    
        roosterClaimed(rawtokenID, owed, animal, unstake){
            let tokenID = utils.formatUnits(rawtokenID._hex, "wei")
            console.log("snakeClaimedFinishCase started", tokenID)
            // find index if emitted token id is ours
            let myToken = this.choosenNfts.findIndex((nft) => nft.id == tokenID)
            if (myToken == -1){
                // console.log(`its not ${tokenID}`)
                return
            }

            if (unstake){
                for (let nft of this.nfts){
                    if (nft.id == tokenID){
                        nft.staked = false
                        this.specifyStakedNft('unstaked')
                        this.specifyStakedNft(nft.animal)
                    }
                }
            }

            this.choosenNfts.splice(myToken, 1)
            if (this.choosenNfts.length == 0){
                this.playClaimSuccess(animal,tokenID, owed , unstake)
                this.clearNftDetail()
            }else{
                // wait until all sent token responses back 
                console.log("still we need to wait other nft claim results:", this.choosedToStakeNfts)
            }
        },
        snakeClaimed(rawtokenID, owed, animal, unstake){ 

            let tokenID = utils.formatUnits(rawtokenID._hex, "wei")
            console.log("snakeClaimedFinishCase started", tokenID)
            // find index if emitted token id is ours
            let myToken = this.choosenNfts.findIndex((nft) => nft.id == tokenID)
            if (myToken == -1){
                // console.log(`its not ${tokenID}`)
                return
            }

            if (unstake){
                for (let nft of this.nfts){
                    if (nft.id == tokenID){
                        nft.staked = false
                        this.specifyStakedNft('unstaked')
                        this.specifyStakedNft(nft.animal)
                    }
                }
            }

            this.choosenNfts.splice(myToken, 1)
            if (this.choosenNfts.length == 0){
                this.playClaimSuccess(animal,tokenID, owed , unstake)
                this.clearNftDetail()
            }else{
                // wait until all sent token responses back 
                console.log("still we need to wait other nft claim results:", this.choosedToStakeNfts)
            }
        },
        refreshUnstakedNfts(){
            // we have to remove unstaked elements from nfts because of duplication
            this.nfts = this.nfts.filter(element => element.staked == true)
            this.getNfts()
        }
    },
    mounted() {
        this.initiate()

        // TokenStaked
        this.coopContract.on("TokenStaked", (account, tokenID, staked, timestamp) => {
            console.log("staked imitated")
            this.tokenStaked(tokenID)
        })

        // SnakeClaimed
        this.coopContract.on("SnakeClaimed", (tokenID, unstake, owed) => {
            this.snakeClaimed(tokenID, owed, "snake", unstake)
        })
        
        // ChickenClaimed
        this.coopContract.on("ChickenClaimed", (tokenID, unstake, owed, risked) => {
            // FIXME this block valid until new contracts deployed
            if (this.riskyClaim){
                risked = Math.floor(Math.random(1, 3) * 2) + 1 // always 1 or 2
            }
            this.chickenClaimed(tokenID, owed, "chicken", unstake, risked)
        })
        
        // RoosterClaimed
        this.coopContract.on("RoosterClaimed", (tokenID, unstake, owed) => {
            this.chickenClaimed(tokenID, owed, "rooster", unstake)
        })
    },
    watch: {
        choosedMintingAmount: function (val) {
            let total = utils.formatUnits(this.mintingPrice) * val
            this.mintingPriceRepresentation = total
        }
    },
    beforeDestroy() {
        clearInterval(this.ticker)
    }

}
</script>

<style>
.nft-details{
    background-image: url('../assets/images/welcome-page.webp');
    background-repeat: no-repeat;
    background-size: 598px 797px;
    width: 598px;
    height: 797px;
    margin:0 auto
}
.choseen-nft-length{
    margin-top: -20px;
    margin-left: 30px;
    color:white;
    font-size:20px;
    text-shadow: -1px 1px 0 #000,
                          1px 1px 0 #000,
                         1px -1px 0 #000,
                        -1px -1px 0 #000;
}
.stake-button-text{
    color: #907242;
    position: absolute;
    font-size: 18px;
    width: 100%;
    height: 100%;
    top: 50%;
    transform: translateY(-50%);
}
.stake-button-text:hover{
    text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287;
}
.close-button{
    position: absolute;
    background: none;
    border: none;
    top:37px;
    right: 37px;
}
.stake-button-image{
    width: 128px;
    height: 30px;
}
.coop-bg{
    background-image: url('../assets/images/coop.webp');
}
.lair-bg{
    background-image: url('../assets/images/lair.webp');
}
.cave-bg{
    background-image: url('../assets/images/cave.webp');
}
.nft-detail-header{
    font-size: 120px;
    line-height: 130px;
}
.nft-detail-header-mac{
    font-size: 120px;
    line-height: 70px;
    padding-top: 56px;
}
.risky-claim-buttons{
    margin-top: 28px;
}
.nft-detail-image{
    width: 484px;
    height: 452px;
    background-repeat: no-repeat;
    background-size: 484px 452px;
    text-align: center;
}
.nft-detail-image button{
    border:none;
    background:none;
    color:white;
    font-size:60px;
    text-shadow: -2px 2px 0 #000,
                2px 2px 0 #000,
                2px -2px 0 #000,
                -2px -2px 0 #000;
}
.arrows-for-change-nft{
    margin-top: -160px;
    margin-right: -40px;
    margin-left: -30px;
}
.stake-button{
    background: none;
    border: none;
    margin-top: 5px;
    margin-bottom: 5px;
}
.claim-button{
    background: none;
    border: none;
    margin: 0px 30px;
}
.claim-button img{
    width: 205px;
    height: 56px;
}
.claim-button-text{
    color: #907242;
    position: absolute;
    font-size: 30px;
    top: 40%;
    width: 100%;
    transform: translateY(-40%);
}
.claim-button:hover{
    text-shadow:1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287;
}
.unclaim-button-text{
    color: #907242;
    position: absolute;
    font-size: 21px;
    top: 40%;
    width: 100%;
    transform: translateY(-40%);
}
.risky-claim-button-text{
    color: #907242;
    position: absolute;
    font-size: 25px;
    top: 40%;
    width: 100%;
    transform: translateY(-40%);
}
.welcome-text{
    color: #000000;
    font-size: 83px;
}
.nft-image-text-connected-wallet{
    margin: 25px 0 0 64px
}
.nft-information-text-connected-wallet{
    color: #2a2a2a !important;
    font-size: 16.5px !important;
    margin-top: 0px;
    width: 76%;
    margin-left: 10px;
}
.currency-information-text{
    color: #2a2a2a !important;
    font-size: 30px !important;
    margin-top: 10px;
    width: 85%;
    margin-left: 10px;
    text-align: center;
}
.egg-staked{
    font-size: 24px;
    color: black;
}
.error-text{
    font-size: 24px;
    color: red;
    cursor: pointer;
}
.coop-bg img{
    margin-top: 60px;
}
.cave-bg img{
    margin-top: 80px;
}
.lair-bg img{
    margin-top: 60px;
}
.nft-detail-image img{
        height: 380px;
}
@media (max-width: 1300px) {
    .welcome-text{
        color: #000000;
        font-size: 50px;
    }
    .pagination-minus{
        position: absolute;
        left: 0px;
        bottom: 0px;
        background: none;
        border: none;
        color: black;
        font-size: 30px;
    }
    .arrows-for-change-nft{
        margin-top: -115px;
    }
    .nft-detail-image button{
        font-size: 40px;
    }
    .pagination-plus{
        position: absolute;
        right: 0px;
        bottom: 0px;
        background: none;
        border: none;
        color: black;
        font-size: 30px;
    }
    .egg-staked{
        font-size: 15px;
    }
    .error-text{
        font-size: 15px;
    }
    .claim-button{
        margin: 0px 12px;
    }
    .risky-claim-buttons{
        margin-top: 15px;
    }
    .nft-detail-image img{
        height: 250px;
    }
    .claim-button img{
        width: 150px;
        height: 37.5px;
    }
    .coop-bg img{
        margin-top: 70px;
    }
    .cave-bg img{
        margin-top: 85px;
    }
    .lair-bg img{
        margin-top: 70px;
    }
    .claim-button-text{
        font-size: 27px;
    }
    .unclaim-button-text{
        font-size: 15px;
    }
    .risky-claim-button-text{
        font-size: 20px;
    }
    .nft-image-text-connected-wallet{
        margin: 15px 0 0 44px
    }
    .welcome-chicken{
        width: 48px;
        height: 68px;
    }
    .welcome-snake{
        width: 61px;
        height: 60px;
    }
    .welcome-rooster{
        width: 57.3px;
        height: 68px;
    }
    .nft-information-text-connected-wallet{
        color: #2a2a2a !important;
        font-size: 13px !important;
        margin-left: 10px;
    }
    .currency-information-text{
        color: #2a2a2a !important;
        font-size: 20px !important;
        margin-left: 10px;
    }
    .minting-side{
        background-size: 338px 257.3px;
        width: 338px;
        height: 257.3px;
    }
    .nft-detail-header{
        font-size: 70px;
        line-height: 70px;
    }
    .nft-detail-header-mac{
        font-size: 70px;
        line-height: 40px;
        padding-top: 40px;
    }
    .claim-n-unstake-button-text{
        font-size: 13px;
    }
    .close-button{
        top: 25px;
        right: 25px;
    }
    .close-button img{
        width: 25px;
        height: 25px;
    }
    .nft-detail-image{
        width: 330px;
        height: 330px;
        background-size: 330px 330px;
    }
    .nft-details{
        background-size: 398px 552px;
        width: 398px;
        height: 552px;
    }
    .egg-information{
        font-size: 13px;
        margin-top: 10px;
    }
    .unstaked-header{
        font-size: 32.6px;
        margin-top: -20px;
    }
    .unstaken-bar-image{
        width: 300px;
    }
}
@media (max-width: 700px) {
    .nft-detail-image img{
        height: 140px;
    }
    .coop-bg img{
        margin-top: 50px;
    }
    .lair-bg img{
        margin-top: 50px;
    }
    .cave-bg img{
        margin-top: 63px;
    }
    .nft-detail-image button{
        font-size: 30px;
    }
    .arrows-for-change-nft{
        margin-top: -70px;
        margin-left: -10px;
        margin-right: -15px;
    }
    .egg-staked{
        font-size: 15px;
        color: black;
    }
    .egg-information{
        margin-bottom: 5px;
    }
    .unstaked-header{
        margin-top: -22px !important;
    }
    .stake-button-image{
        width: 102px;
        height: 32px;
    }
    .welcome-chicken{
        width: 40px;
        height: 60px;
    }
    .welcome-snake{
        width: 40px;
        height: 40px;
    }
    .welcome-rooster{
        width: 40px;
        height: 50px;
    }
    .farm-side{
        background-size: 320px 287.3px;
        width: 320px;
        height: 287.3px;
    }
    .nft-detail-header{
        font-size: 60px;
        line-height: 50px;
        padding-top: 20px;
    }
    .risky-claim-buttons{
        margin-top: 0;
    }
    .claim-button-text{
        font-size: 20px;
    }
    .unclaim-button-text{
        font-size: 13px;
    }
    .risky-claim-button-text{
        font-size: 15px;
    }
    .currency-information-text{
        font-size: 20px !important;
    }
    .nft-details{
        background-size: 298px 392px;
        width: 298px;
        height: 392px;
    }
    .nft-detail-image{
        width: 200px;
        height: 200px;
        background-size: 200px 200px;
    }
    .claim-button{
        margin: 10px 8px;
    }
    .claim-button img{
        width: 120px;
        height: 30px;
    }
    .welcome-text{
        font-size: 25px;
    }
    .nft-image-text-connected-wallet{
        margin: 10px 0 0 20px;
    }
    .nft-information-text-connected-wallet{
        font-size: 10px !important;
    }
    .currency-information-text{
        line-height: 20px;
    }
    .claim-n-unstake-button-text{
        font-size: 10px;
    }
    @supports (-webkit-touch-callout: none) {
            .nft-detail-header{
                font-size: 60px;
                line-height: 40px;
                padding-top: 30px;
            }
            .claim-button{
                margin: 8px -10px;
            }
            .risky-claim-buttons{
                margin-top: 0px;
            }
            .close-button{
                top: 20px;
                right: 10px;
            }
    }
}

</style>
